/**
 * Service pour les opérations sur les argumentaires commerciaux
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const formationArgumentaireService = {
  // Liste tous les argumentaires
  list: () => api.get(endpoints.formations.argumentaires.list()),

  // Liste les argumentaires par type (formation ou general)
  listByType: (type) => api.get(endpoints.formations.argumentaires.byType(type)),

  // Liste les argumentaires pour une formation spécifique
  listByFormation: (formationNom) =>
    api.get(endpoints.formations.argumentaires.byFormation(formationNom)),

  // Récupère les argumentaires pour un devis (formation-specific + general)
  getForQuote: (formationNom) =>
    api.get(endpoints.formations.argumentaires.forQuote(formationNom)),

  // Liste des formations qui ont des argumentaires
  getFormationsList: () => api.get(endpoints.formations.argumentaires.formationsList()),

  // Récupère un argumentaire par ID
  get: (id) => api.get(endpoints.formations.argumentaires.detail(id)),

  // Crée un nouvel argumentaire
  create: (data) => api.post(endpoints.formations.argumentaires.create(), data),

  // Met à jour un argumentaire
  update: (id, data) => api.put(endpoints.formations.argumentaires.update(id), data),

  // Supprime un argumentaire
  delete: (id) => api.delete(endpoints.formations.argumentaires.delete(id))
}
